import * as actionTypes from './actionTypes';

export const mapEthnicityNextStep = () => {
  return {
    type : actionTypes.MAP_ETHNICITY_NEXT_STEP,
    val : null
  }
}

export const mapEthnicityGoBack = () => {
  return {
    type : actionTypes.MAP_ETHNICITY_PREVIOUS_STEP,
    val : null
  }
}

export const mapEthnicityUploadFileSuccess = (columns, data, file) => {
  console.log(columns, data, file)
  return {
    type : actionTypes.MAP_ETHNICITY_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapEthnicityMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_ETHNICITY_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllEthnicityMapping = (val) => {
  return {
    type : actionTypes.MAP_ETHNICITY_SAVE_ETHNICITY_MAPPING,
    val : val
  }
}

export const resetEthnicity = () => {
  return {
    type : actionTypes.MAP_ETHNICITY_RESET,
    val : null
  }
}

export const resetMapEthnicityStep = () => {
  return {
    type : actionTypes.MAP_ETHNICITY_RESET_STEP,
    val : null
  }
}
